exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-card {\n  width: 24%;\n  border-radius: 0;\n  background-color: #5c2890;\n  border: 0;\n  margin-right: 8px;\n  margin-bottom: 10px;\n  position: relative;\n  padding-bottom: 50px;\n  box-sizing: border-box; }\n  @media (max-width: 768px) {\n    .c-card {\n      width: 100%;\n      flex: 0 48%; } }\n  .c-card__img {\n    width: 100%;\n    height: 140px; }\n  .c-card__body {\n    padding: 5px 10px;\n    text-align: left; }\n  .c-card__action {\n    padding: 15px 10px 25px;\n    position: absolute;\n    bottom: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/stylesheets/components/card.scss
// module id = 124
// module chunks = 0